<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col v-bind:class="{'mt-md-n10': !noMarginTop && !stackedView}" class="pt-0 d-flex align-start" cols="12" :md="stackedView ? 12 : (showFilters ? 4 : 2)" :order="stackedView ? 2 : 1">
        <v-card class="pb-2" elevation="0" outlined v-show="showFilters">
          <v-row id="player-seasons" class="mx-0 pt-2 justify-start align-baseline">
            <v-col cols="12" class="py-1">
              <v-card-title class="pa-0 header-font py-2" style="font-size: 22px;">{{ $t('general.filters') }}</v-card-title>
              <MediaModeForm v-show="showFilters" v-if="(currentUser.clientType === 'Media' || currentUser.clientType === 'Driblab') && !stackedView" :fields="mediaModeFields"
                :mediaMode="mediaMode" @mediaModeChange="mediaMode = $event"
                :mediaModeData="mediaModeData" @mediaModeDataChange="onMediaModeDataChange($event)"
                :mediaModeFlags="mediaModeFlags" @mediaModeFlagsChange="mediaModeFlags = $event" selectorMode></MediaModeForm>
            </v-col>
            <!--Seasons-->
            <v-col cols="12" md="8" class="py-1">
              <div
                class="mr-5 pt-0 mt-0 primary--text font-weight-bold body-1"
              >
                {{ $t('table.clientLeagues.seasons') }}
              </div>
              <v-autocomplete 
                :items="playerSeasonData" 
                v-model="seasonDataSelectedModel"
                item-value="compoundId" 
                item-text="compoundText"
                clearable
                multiple 
                hide-details 
                dense 
                @change="onSelectChange()" ref="autoCompleteSeasonRef"
                >
                <template v-slot:selection="{item,index}">
                  <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 w-90 black--text" v-if="index <= 2">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="font-weight-bold text-ellipsis">{{item.seasonName}}</span>
                    <span class="mx-1">@</span>
                    <span class="font-weight-medium">{{item.teamName}}</span>
                  </v-chip>
                  <span
                        v-if="index === 3"
                        class="primary--text body-2 subheader-font"
                      >(+{{ seasonDataSelectedModel.length - 3 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <v-card-text
                    class="pa-0 primary--text body-2 font-weight-medium d-flex align-center">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="d-flex flex-column">
                      {{item.seasonName}}
                      <span>{{item.teamName}}</span>
                    </span>
                  </v-card-text>
                </template>
              </v-autocomplete>
            </v-col>
            <!--Filter Games-->
            <v-col cols="12" md="4" class="py-1 pl-1">
              <v-card-title class="pa-0 mr-0 body-1 font-weight-bold primary--text flex-shrink-0">{{ $t("general.filter") }} {{ $t("searchbar.games") }}</v-card-title>
              <v-card-text class="pa-0 flex-shrink-1">
                <v-autocomplete clearable class="pa-0 body-2 mb-2" hide-details dense
                  v-model="groundModel"
                  :items="grounds"
                  item-text="name"
                  item-value="id"
                  @change="onSelectChange()"
                >
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 w-80 d-flex justify-center black--text" v-if="index <= 0">
                      <span class="body-2 text-ellipsis">{{item.name}}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2">{{item.name}}</span>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <!--Games-->
            <v-col cols="12" class="py-1">
              <v-card-title class="pa-0 mr-4 body-1 font-weight-bold primary--text flex-shrink-0">{{ $t("searchbar.games") }}</v-card-title>
              <v-card-text class="pa-0 flex-shrink-1">
                <v-autocomplete clearable multiple menu-props="auto" hide-details dense class="pa-0 body-2 mb-2"
                  v-model="gamesModel"
                  :items="gamesFiltered"
                  item-text="name"
                  item-value="gameId"
                  @blur="updateShots()"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleGames">
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="body-2">{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text" v-if="index <= 0">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`" type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="body-2 text-ellipsis">{{item.name}}</span>
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`" type="image/png" height="20" class="ml-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                    </v-chip>
                    <span v-if="index === 1" class="primary--text body-2 subheader-font">(+{{ gamesModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`" type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="body-2">{{item.name}}</span>
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`" type="image/png" height="20" class="ml-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col class="d-flex pb-3 pl-0 justify-center" cols="12" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn color="primary" small class="body-2" outlined @click="showShotOptions = !showShotOptions">
                  {{ showShotOptions ? $t('game.detail.hidePassOptions') : $t('game.detail.showPassOptions')}} <v-icon right > {{ showShotOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
              </v-btn>
            </v-col>
            <v-row id="passing-location" class="mx-0">
              <v-col cols="12" v-if="showShotOptions" class="py-0">
                <div class="mt-2 mb-n2 primary--text font-weight-bold body-1">{{ $t('general.visualization') }}</div>
              </v-col>
              <v-col class="pt-0 pb-2 d-flex flex-wrap" cols="12" v-if="showShotOptions">
                <v-checkbox
                  v-model="checkboxCircles"
                  :label="$t('finishingMap.circles')"
                  color="secondary"
                  value="circles"
                  hide-details
                  class="pa-0 me-5"
                  @change="updateShots"
                ><template v-slot:label><span class="body-1 primary--text">{{ $t('finishingMap.circles') }}</span></template></v-checkbox>
                <v-checkbox
                  v-model="checkboxCircles"
                  :label="$t('finishingMap.boxes')"
                  color="secondary"
                  value="boxes"
                  hide-details
                  class="pa-0"
                  @change="updateShots"
                ><template v-slot:label><span class="body-1 primary--text">{{ $t('finishingMap.boxes') }}</span></template></v-checkbox>
              </v-col>
            </v-row>
          </v-row>
          <v-row id="shot-filters" class="mx-0">
            <v-col class="py-2" cols="12" sm="12" v-if="showShotOptions">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.areas') }}</p>
              <v-btn small @click="onSelectAreaClick()" rounded class="elevation-0 monospace-font white--text px-2 my-1" color="secondary">
                <v-icon color="white" x-small>filter_list</v-icon>
                <span class="ms-1">{{ `${$t('areaSelector.filterAreas')} (${areaModel.length}/${currentUserAreas.length})` }}</span>
              </v-btn>
              <AreaSelectorModal 
                ref="areaSelectorModalRef" 
                v-if="player"
                :title="`${$t('playerDetail.keyPassMap')} - ${$t('areaSelector.selectAreas')}`"
                :areaModel="areaModel"
                :isVertical="true"
                @onConfirmClick="onAreaSelectorConfirm($event)"
              ></AreaSelectorModal>
            </v-col>
            <v-col class="py-2" cols="12" sm="12" v-if="showShotOptions">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.typesOfShot') }}</p>
              <v-autocomplete clearable hide-details dense
                :items="shotTypes"
                v-model="shotTypeModel"
                item-text="text"
                item-value="id"
                class="pa-0"
                multiple
                @input="updateShots();"
              >
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleShotTypes"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                ></v-divider>
                <template
                  slot="selection"
                  slot-scope="{ item, index }"
                >
                  <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                    <span class="black--text">&nbsp;{{ item.text }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="primary--text body-2 subheader-font"
                  >(+{{ shotTypeModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <span class="body-2 primary--text">{{item.text}}</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="py-2" cols="12" sm="12" v-if="showShotOptions">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.shotStrategy') }}</p>
              <v-autocomplete clearable hide-details dense
                :items="shotStrategies"
                v-model="shotStrategyModel"
                item-text="text"
                item-value="id"
                class="pa-0"
                multiple
                @input="onStrategyInput();"
              >
              <v-list-item
                slot="prepend-item"
                ripple
                @click="toggleShotStrategies"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                slot="prepend-item"
              ></v-divider>
                <template
                  slot="selection"
                  slot-scope="{ item, index }"
                >
                  <template v-if="!item.isGroupHeader">
                    <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                      <span class="black--text">&nbsp;{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-else-if="index === 1"
                      class="primary--text body-2 subheader-font"
                    >(+{{ shotStrategyModel.filter(id => id !== 'group_open' && id !== 'group_set').length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                </template>
                <template v-slot:item="{item}">
                  <div v-if="item.isGroupHeader" class="d-flex align-center" style="width:100%">
                    <v-icon small class="mr-2" color="secondary">{{ isStrategyGroupSelected(item.id) ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
                    <span class="body-2 primary--text font-weight-bold">{{ item.text }}</span>
                  </div>
                  <span v-else class="body-2 primary--text">{{item.text}}</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="py-2" cols="12" sm="12" v-if="showShotOptions">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.bodyPart') }}</p>
              <v-autocomplete clearable dense
                :items="bodyParts"
                v-model="bodyPartModel"
                item-text="text"
                item-value="id"
                class="pa-0"
                multiple
                @input="updateShots();"
                hide-details
              >
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleBodyPart"
                >
                <v-list-item-content>
                  <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                ></v-divider>
                  <template
                    slot="selection"
                    slot-scope="{ item, index }"
                  >
                  <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                    <span class="black--text">&nbsp;{{ item.text }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="primary--text body-2 subheader-font"
                  >(+{{ bodyPartModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <span class="body-2 primary--text">{{item.text}}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row id="filters">
            <v-col class="d-flex py-2" cols="12" sm="12" v-if="showShotOptions">
              <v-range-slider
                :label="$t('finishingMap.minutes')"
                thumb-label
                v-model="minutes"
                :min="rangeMinutes[0]"
                :max="rangeMinutes[1]"
                step="1"
                hide-details
                :color="`secondary ${$vuetify.theme.dark ? 'lighten-3' : ''}`"
                class="align-center px-3 py-0"
                @input="updateShots"
              >
                <template v-slot:label>
                  <div class="d-flex flex-column">
                    <span class="primary--text font-weight-bold body-1">{{ $t('finishingMap.minutes') }}</span>
                    <span class="body-2 subheader-font monospace-font">{{ `(${rangeMinutes[0]} - ${rangeMinutes[1]})` }}</span>
                  </div>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
          <!--Download actions-->
          <div v-if="!stackedView" class="pb-2 px-1 mt-5">
            <v-divider></v-divider>
          </div>
          <div v-if="!stackedView" class="d-flex justify-end py-0 w-100 pr-1" id="image-download">
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsPNG()">
              <v-icon small class="mr-1">file_download</v-icon>
              <span class="">PNG</span>
            </v-btn>
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsSVG()">
              <v-icon small class="mr-1">file_download</v-icon>
              <span>SVG</span>
            </v-btn>
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" :loading="loadingExport" v-on:click.native="onGenerateIFrameClick()">
              <v-icon small class="mr-1">share</v-icon>
              <span>Embed</span>
            </v-btn>
          </div>
        </v-card>
        <div class="flex-shrink-0 ml-2 align-self-start">
          <slot name="filters-toggle"></slot>
        </div>
      </v-col>
      <v-col cols="12" sm="12" :md="stackedView ? 12 : (showFilters ? 8 : 10)" id="chart" ref="chart" class="text-center px-0" :order="stackedView ? 1 : 2" v-bind:class="{'py-0':stackedView}">
        <PlayerAvatarMedia v-if="avatarSize && mediaMode" :width="size" :height="avatarSize.height" :id="`${player.playerId}-${this.chartId}`"
          :margin="margin" :title="mediaModeData.upperText" :subtitle="mediaModeData.lowerText"
          :color="mediaModeData.borderColor" ref="playerAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :player="headerPlayer"
          :face="mediaModeData.face.dataUrl"
          :nationalTeam="mediaModeData.nationalTeam"
          type="keyPassMap" :lineDistance="mediaModeData.lineLength" :avatarSize="mediaModeData.avatarSize" :lineWeight="mediaModeData.lineWeight"
          :upperTextFontSize="mediaModeData.upperTextFontSize" :upperTextFontWeight="mediaModeData.upperTextFontWeight"
          :lowerTextFontSize="mediaModeData.lowerTextFontSize" :lowerTextFontWeight="mediaModeData.lowerTextFontWeight"
          :fontFamily="mediaModeData.fontFamily"
          class=""></PlayerAvatarMedia>
        <XAChart
          v-if="size != 0"
          :size="size"
          :passes="filteredShots"
          :margin="margin"
          :type="type"
          :key="xaMap"
          :playerId="playerId"
          :seasons="filteredSeasons"
          :playerName="player.name"
          :circlesAndBoxes="checkboxCircles"
          :language="currentUserLanguage"
          :mediaMode="mediaMode"
          :id="`${player.playerId}-${this.chartId}`"
          :gameId="gameId"
          :gameIds="gameIds.length ? gameIds : gamesModel"
          :gameName="gameName"
          :minsPlayed="minsPlayed"
          :fontFamily="mediaModeData.fontFamily"
          :teamId="teamId || 0"
          :filterShotTypeText="filterShotTypeText"
          :filterShotStrategyText="filterShotStrategyText"
          :filterBodyPartText="filterBodyPartText"
          :filterMinutesText="filterMinutesText"
          ref="xaChart"
          @sizeChange="onChartSizeChange($event)"
          @loaded="onLoaded($event)"
        />
        <DriblabSocialMedia v-if="avatarSize && size && mediaMode && mediaModeData.socialMedia"  :player="player" :width="size" :height="50" :id="`${player.playerId}-${this.chartId}`"
          :margin="margin" ref="driblabSocialMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :fontSize="mediaModeData.socialMediaFontSize" :fontWeight="mediaModeData.socialMediaFontWeight" :sponsor="mediaModeData.sponsor.dataUrl"
          :fontFamily="mediaModeData.fontFamily"
          :logoCfg="mediaModeData.logo" type="keyPassMap"></DriblabSocialMedia>
      </v-col>
    </v-row>
    <ChartExportLinksModal ref="chartExportLinksModalRef" :title="player.name"
    :subtitle="$t('playerDetail.keyPassMap')"></ChartExportLinksModal>
    <Tour v-if="currentUser.showTour && playerSeasonData && playerSeasonData.length" name="playerKeyPassTour" :steps="tourSteps" />
  </v-container>
</template>

<script>
import * as d3 from "d3";
import * as _ from 'lodash';

import Dictionary from '../../dictionary';
import PlayerService from '../../services/player/player.service';
import GameService from '../../services/game/game.service';
import XAChart from '../base/XAChart';
import { exportSvg,downloadPng,copyAndAppendElement } from '../../utils/exportToPNG'
import PlayerAvatarMedia from './PlayerAvatarMedia';
import DriblabSocialMedia from '../base/DriblabSocialMedia';
import MediaModeForm from '../base/MediaModeForm';
import { userHasRole, getLeagueAndYearName,coordToArea } from '../../utils/functions';
import UserChartService from '../../services/user-chart.service';
import ChartExportLinksModal from '../base/ChartExportLinksModal';
import Tour from "../base/Tour";
import DocumentService from '../../services/document.service';
import { v4 } from 'uuid';
import UserService from '../../services/user.service';
import * as moment from 'moment';
import AreaSelectorModal from "../modals/AreaSelectorModal.vue";

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/'

export default {
  name: 'PlayerXAMap',
  components: {
    XAChart,
    PlayerAvatarMedia,
    DriblabSocialMedia,
    MediaModeForm,
    ChartExportLinksModal,
    Tour,
    AreaSelectorModal
  },
  props:{
    noMarginTop: { type: Boolean, default: false },
    playerId:{
      type: Number,
      required: false
    },
    stackedView:{
      type: Boolean,
      required: false
    },
    chartId:{
      type: Number,
      default: 0
    },
    mediaModeCfg:{
      type: Object,
      required: false
    },
    mediaModeValue:{
      type: Boolean,
      required: false
    },
    headerPlayer:{
      type: Object,
      required: false
    },
    headerPlayerSeasonData:{
      type: Array,
      required: false
    },
    gamesPlayed:{
      type: Array,
      required: false
    },
    gameId:{
      type:Number,
      default: 0
    },
    gameName:{
      type: String,
      default: ""
    },
    language: {
      type: String,
      required: false
    },
    gameIds: {
      type: Array,
      required: false,
      default: () => []
    },
    showFilters: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage() {
      return this.language ? this.language : this.$store.getters["auth/language"];
    },
    currentUserAreas(){
      let layoutId = this.$store.getters["auth/fieldLayout"]
      return _.chain(this.layouts).find(l => l.id === layoutId).get("areas").reduce((allAreas,a) => {
        allAreas.push(a);
        return allAreas;
      },[]).value();
    },
    layouts(){
      return this.$store.getters["general/fieldLayouts"];
    },
    allShotTypes () {
      return this.shotTypeModel.length === this.shotTypes.length
    },
    allShotStrategies () {
      return this.shotStrategyModel.length === this.shotStrategies.filter(s => !s.isGroupHeader).length
    },
    allBodyParts () {
      return this.bodyPartModel.length === this.bodyParts.length
    },
    filterShotTypeText () {
      if (this.allShotTypes) return this.$t('general.all');
      const selected = this.shotTypes.filter(s => this.shotTypeModel.includes(s.id));
      if (!selected.length) return '—';
      if (selected.length === 1) return selected[0].text;
      return selected[0].text + ` +${selected.length - 1}`;
    },
    filterShotStrategyText () {
      if (this.allShotStrategies) return this.$t('general.all');
      const selected = this.shotStrategies.filter(s => !s.isGroupHeader && this.shotStrategyModel.includes(s.id));
      if (!selected.length) return '—';
      const selectedIds = selected.map(s => s.id);
      const allOpenPlay = this.openPlayIds.every(id => selectedIds.includes(id));
      const anySetPiece = this.setPieceIds.some(id => selectedIds.includes(id));
      const allSetPiece = this.setPieceIds.every(id => selectedIds.includes(id));
      const anyOpenPlay = this.openPlayIds.some(id => selectedIds.includes(id));
      if (allOpenPlay && !anySetPiece) return Dictionary[this.$i18n.locale]["finishingMap"]["openPlay"];
      if (allSetPiece && !anyOpenPlay) return Dictionary[this.$i18n.locale]["finishingMap"]["setPiece"];
      if (allOpenPlay && allSetPiece) return this.$t('general.all');
      if (selected.length === 1) return selected[0].text;
      return selected[0].text + ` +${selected.length - 1}`;
    },
    filterBodyPartText () {
      if (this.allBodyParts) return this.$t('general.all');
      const selected = this.bodyParts.filter(b => this.bodyPartModel.includes(b.id));
      if (!selected.length) return '—';
      if (selected.length === 1) return selected[0].text;
      return selected[0].text + ` +${selected.length - 1}`;
    },
    filterMinutesText () {
      if (this.minutes[0] === this.rangeMinutes[0] && this.minutes[1] === this.rangeMinutes[1]) return '';
      return `${this.$t('table.roster.minutes')}: ${this.minutes[0]}' - ${this.minutes[1]}'`;
    },
    teamId(){
      if(this.seasonDataSelectedModel && this.seasonDataSelectedModel.length){
        const found = _.find(this.playerSeasonData,(sd) => sd.compoundId === this.seasonDataSelectedModel[0]);
        return found ? found.teamId : undefined;
      }
    },
    lastSearchId() {
      return this.$store.state.auth.lastSearch;
    },
    allGames () {
      return this.gamesModel.length === this.gamesFiltered.length;
    },
    darkMode(){
      return this.currentUser.darkMode || this.$vuetify.theme.dark
    },
    isGoalkeeper(){
      if (this.headerPlayer) return this.headerPlayer.fieldPositionId === 1; //GK
    },
    tourSteps(){
      return [
        {
          target: `#player-seasons`,
          header: {
            title: this.$t("tours.playerKeyPass.step1.title"),
          },
          content: this.$t("tours.playerKeyPass.step1.message"),
          params: {
            placement: "top",
            eenableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#passing-location`,
          header: {
            title: this.$t("tours.playerKeyPass.step2.title"),
          },
          content: this.$t("tours.playerKeyPass.step2.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#shot-filters`,
          header: {
            title: this.$t("tours.playerKeyPass.step3.title"),
          },
          content: this.$t("tours.playerKeyPass.step3.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#filters`,
          header: {
            title: this.$t("tours.playerKeyPass.step4.title"),
          },
          content: this.$t("tours.playerKeyPass.step4.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#image-download`,
          header: {
            title: this.$t("tours.playerKeyPass.step5.title"),
          },
          content: this.$t("tours.playerKeyPass.step5.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#chart`,
          header: {
            title: this.$t("tours.playerKeyPass.step6.title"),
          },
          content: this.$t("tours.playerKeyPass.step6.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
      ];
    }
  },
  data() {
    return {
      size: 0,
      margin: null,
      grounds: [{id: 1, name: this.$t("general.all")},
                {id: 2, name: this.$t("general.home")},
                {id: 3, name: this.$t("general.away")},
                {id: 4, name: this.$t('general.last') + ' ' + this.$t('playerRecruitment.xGames',{0:6})},
                {id: 5, name: this.$t('general.last') + ' ' + this.$t('playerRecruitment.xGames',{0:12})}],
      groundModel: 1,
      type: "player",
      player: null,
      xaMap: 0,
      shots:[],
      filteredShots: [],
      seasonDataSelectedModel: [],
      playerSeasonData: [],
      filteredSeasons: [],
      shotTypes: "${player.position}" == "GK" ? [
        {id: 16, text: Dictionary[this.$i18n.locale]["finishingMap"]["goal"]},
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["savedShot"]}
      ] : [
        {id: 16, text: Dictionary[this.$i18n.locale]["finishingMap"]["goal"]},
        {id: 13, text: Dictionary[this.$i18n.locale]["finishingMap"]["missedShot"]},
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["savedShot"]},
        {id: 14, text: Dictionary[this.$i18n.locale]["finishingMap"]["shotOnPost"]},
        {id: 60, text: Dictionary[this.$i18n.locale]["finishingMap"]["missedChance"]}
      ],
      shotTypeModel: "${player.position}" == "GK" ? [15, 16] : [13, 14, 15, 16, 60],
      openPlayIds: [22, 23, 123, 215],
      setPieceIds: [26, 24, 25, 124, 160, 279],
      shotStrategies: [
        {id: 'group_open', text: Dictionary[this.$i18n.locale]["finishingMap"]["openPlay"], isGroupHeader: true},
        {id: 22, text: Dictionary[this.$i18n.locale]["finishingMap"]["regularPlay"]},
        {id: 23, text: Dictionary[this.$i18n.locale]["finishingMap"]["fastBreak"]},
        {id: 123, text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]["keeperThrowPlay"]},
        {id: 215, text: Dictionary[this.$i18n.locale]["finishingMap"]["individualPlay"]},
        {id: 'group_set', text: Dictionary[this.$i18n.locale]["finishingMap"]["setPiece"], isGroupHeader: true},
        {id: 26, text: Dictionary[this.$i18n.locale]["finishingMap"]["freeKick"]},
        {id: 24, text: Dictionary[this.$i18n.locale]["finishingMap"]["indirectFreeKick"]},
        {id: 25, text: Dictionary[this.$i18n.locale]["finishingMap"]["fromCorner"]},
        {id: 124, text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]["gkKick"]},
        {id: 160, text: Dictionary[this.$i18n.locale]["finishingMap"]["throwInSetPiece"]},
        {id: 279, text: Dictionary[this.$i18n.locale]["videoHighlights"]["qualifierIds"]["279"]}
      ],
      shotStrategyModel: [22, 23, 215, 24, 25, 26, 160, 123, 124, 279],
      areaModel: [],
      bodyParts: [
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["head"]},
        {id: 72, text: Dictionary[this.$i18n.locale]["finishingMap"]["leftFooted"]},
        {id: 20, text: Dictionary[this.$i18n.locale]["finishingMap"]["rightFooted"]},
        {id: 21, text: Dictionary[this.$i18n.locale]["finishingMap"]["otherBodyPart"]}
      ],
      bodyPartModel: [15, 20, 21, 72],
      minutes: [0, 90],
      checkboxCircles: ['circles'],
      showShotOptions: this.$vuetify.breakpoint.smAndDown ? false : true,
      rangeMinutes: [0,90],
      mediaMode: false,
      mediaModeFields: [
        {type:"text",label:"mediaMode.upperText",key:"upperText"},
        {type:"number",label:"mediaMode.upperTextFontSize",key:"upperTextFontSize"},
        {type:"radio",label:"mediaMode.upperTextFontWeight",key:"upperTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"text",label:"mediaMode.lowerText",key:"lowerText"},
        {type:"number",label:"mediaMode.lowerTextFontSize",key:"lowerTextFontSize"},
        {type:"radio",label:"mediaMode.lowerTextFontWeight",key:"lowerTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"radio",label:"mediaMode.fontFamily",key:"fontFamily",options:[{value:"NeueMontreal",label:"NeueMontreal"},{value:"NeueMontreal",label:"NeueMontreal"}]},
        {type:"color",label:"mediaMode.borderColor",key:"borderColor"},
        {type:"color",label:"mediaMode.bgColor",key:"bgColor"},
        {type:"color",label:"mediaMode.textColor",key:"textColor"},
        {type:"number",label:"mediaMode.avatarLineLength",key:"lineLength",force:true},
        {type:"number",label:"mediaMode.avatarLineWeight",key:"lineWeight",force:true},
        {type:"number",label:"mediaMode.avatarSize",key:"avatarSize",force:true},
        {type:"image",label:"mediaMode.face",key:"face"},
        {type:"switch",label:"mediaMode.nationalTeam",key:"nationalTeam"},
        {type:"switch",label:"mediaMode.socialMedia",key:"socialMedia"},
        {type:"number",label:"mediaMode.socialMediaFontSize",key:"socialMediaFontSize",force:true},
        {type:"radio",label:"mediaMode.socialMediaFontWeight",key:"socialMediaFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"image",label:"mediaMode.sponsor",key:"sponsor",force:true,aspectRatio:16/9,imageRestriction:'none',resizable:true,stencilSize:{width:300,height:300}}
      ],
      chartSize: null,
      avatarSize: null,
      mediaModeFlags: {borderColor:null,bgColor:null,upperText:null,lowerText:null,socialMedia:null, nationalTeam: null,textColor: null,face:null},
      mediaModeData: {borderColor:"#3366FF",bgColor:"#ffffff0",upperText:null,lowerText:null,socialMedia:true,nationalTeam: false,textColor:"#000000",face: {},upperTextFontWeight:"900",lowerTextFontWeight:"400"
      ,socialMediaFontWeight:"300",socialMediaFontSize:"14",sponsor:{}},
      loadingExport: false,
      games: [],
      gamesFiltered: [],
      gamesModel: [],
      //Mins played on games selected
      minsPlayed: 0,
      //mapType: 'keyPassMap'
    };
  },
  watch:{
    "mediaMode": function(newVal, oldVal) {
      if(!this.stackedView){
        if(!this.mediaMode){
          this.mediaModeData =  {borderColor:"#3366FF",bgColor:"#ffffff0",upperText:null,lowerText:null,
          socialMedia:true,nationalTeam: false,textColor:"#000000",face:{},upperTextFontWeight:"900",
          lowerTextFontWeight:"400",socialMediaFontWeight:"400",socialMediaFontSize:"14",sponsor:{}}
        }
        this.mediaModeData.bgColor = this.mediaMode ? '#ffffff' : '#ffffff0';
        this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
        this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0_${this.headerPlayer.male === false ? 'f' : 'm'}.png`;
        this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
        this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      }
    },
    "mediaModeCfg":function(newVal,oldVal){
      if(_.size(_.keys(newVal))){
        this.onMediaModeDataChange(newVal);
      }
    },
    "mediaModeValue":function(newVal,oldVal){
      if(!_.isEqual(newVal,oldVal)){
        this.mediaMode = newVal
      }
    },
    showFilters() {
      this.$nextTick(() => {
        this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75; // minus padding normal
        this.onWindowResize(null, true);
      });
    }
  },
  mounted: function() {
    this.mediaMode = this.stackedView ? this.mediaModeValue : (this.currentUser.mediaMode || this.currentUser.clientType === 'Media');
    this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75; // minus padding normal

    this.margin = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  },
  async created() {
    window.addEventListener("resize", this.onWindowResize);
    this.player = this.headerPlayer;
    this.games = this.gamesPlayed;

    if(this.headerPlayerSeasonData){
      this.playerSeasonData = _.map(this.headerPlayerSeasonData, (h) => { h.compoundId = `${h.seasonId}-${h.teamId}`; h.compoundText = `${h.seasonName}-${h.teamName}`; return h; });
    }else{
      let seasonsData = await PlayerService.getPlayerTeamSeasonData(this.playerId, this.currentUser.clientId);
      this.playerSeasonData = _.map(seasonsData.data,(h) => { h.compoundId = `${h.seasonId}-${h.teamId}`; h.compoundText = `${h.seasonName}-${h.teamName}`; return h; });
    }
    this.playerSeasonData.forEach(s => {
      const league = s.league || (s.label != null ? s : null);
      const year = s.year != null ? s.year : (s.seasonYear != null ? s.seasonYear : null);
      if (league && year != null) {
        s.seasonAlias = getLeagueAndYearName(league, year);
      }
    });
    this.filteredSeasons = this.playerSeasonData.slice(0, 1);

    //Get games of player if games are not received
    if(!this.games){
      await this.loadGamesPlayedOfPlayer();
    }
    //Get shots of player
    let shotsData = await GameService.getXAPassesOfSinglePlayer(this.playerId, this.playerPosition);
    this.shots = _.map(shotsData.data,(s) => {
        //Areas
        let startArea = coordToArea(s.x,s.y,this.currentUserAreas);
        s.startAreaId = _.get(startArea,'id');
        s.startAreaName = _.get(startArea,'name');
        let endArea = coordToArea(s.x_end,s.y_end,this.currentUserAreas);
        s.endAreaId = _.get(endArea,'id');
        s.endAreaName = _.get(endArea,'name');

        return s
    });


   // Default season : Last Regular season of the player's team
   let defaultSeason = this.playerSeasonData.find(psd => psd.regular && 
                                          psd.teamId === this.player.teamId && 
                                          psd.year === psd.leagueLastYear);

    if(!defaultSeason){
      // If there is no season, take last regular played in other team
      defaultSeason = this.playerSeasonData.find(psd => psd.regular && 
                                        psd.year === psd.leagueLastYear);
    }

    if(!defaultSeason){
      // If there is no season, take first regular from all seasons played
      defaultSeason = this.playerSeasonData.find(psd => psd.regular) || this.playerSeasonData[0];
    }

    this.seasonDataSelectedModel = [defaultSeason.compoundId];
    this.filterGames();
    this.updateMins();
    this.updateShots();
    this.mediaModeData.upperText = this.player.name;
    this.mediaModeData.lowerText = this.$t("playerDetail.keyPassMap");
    this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
    this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0_${this.headerPlayer.male === false ? 'f' : 'm'}.png`;
    this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
    this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);

    setTimeout(() => {
      UserService.putLastSearchRendered({id:this.lastSearchId});
    }, 250);

  },
  methods: {
    onWindowResize(e,force = false) {
      setTimeout(() => {
        force = force || (e && e.type === "resize");
        if(this.$refs.chart){
          this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75;
        }
        if(this.$refs.xaChart){
          this.$refs.xaChart.printD3(force)
        }
        if(this.$refs.playerAvatarMediaRef){
          this.$refs.playerAvatarMediaRef.printD3(force)
        }
        if(this.$refs.driblabSocialMediaRef){
          this.$refs.driblabSocialMediaRef.printD3(force)
        }
        this.$forceUpdate();
      },100)
    },
    toggleGames () {
      this.$nextTick(() => {
        if (this.allGames)
          this.gamesModel = []
        else {
          this.gamesModel = this.gamesFiltered.slice().map(g => g.gameId);
        }
      })
    },
    filterGames(){
      this.filteredSeasons = this.playerSeasonData.filter(s => this.seasonDataSelectedModel.includes(s.compoundId));
      let teamIds = this.filteredSeasons.map(s => s.teamId);
      let seasonIds = this.filteredSeasons.map(s => s.seasonId);
      let gamesOfSeasonAndTeam = this.games.filter(s => teamIds.includes(s.teamId) && seasonIds.includes(s.seasonId));
      switch (this.groundModel) {
        //All
        case 1:
          this.gamesFiltered = gamesOfSeasonAndTeam;
          break;
        //Home
        case 2:
          this.gamesFiltered = gamesOfSeasonAndTeam.filter(g => teamIds.includes(g.homeTeamId));
          break;
        //Away
        case 3:
          this.gamesFiltered = gamesOfSeasonAndTeam.filter(g => teamIds.includes(g.awayTeamId));
          break;
        case 4:
        case 5:
          this.gamesFiltered = gamesOfSeasonAndTeam.slice(0, this.groundModel === 4 ? 6 : 12);
          break;
        default:
          this.gamesFiltered = gamesOfSeasonAndTeam;
      }

      this.gamesModel = this.gamesFiltered.map(g => g.gameId);
    },
    onSelectChange(){
      this.filterGames();
      this.updateShots();
    },
    async loadGamesPlayedOfPlayer() {
      let gamesResponse = await PlayerService.getGamesPlayedOfPlayer(this.playerId);
      this.games = gamesResponse.data;
      //Create game name
      this.games.forEach(g => {
        g.name = `${g.homeTeamName} ${g.homeTeamScore}:${g.awayTeamScore} ${g.awayTeamName}`;
      });
    },
    shotsInArea(shots) {
      return shots
        .filter(s => this.areaModel.includes(s.startAreaId) || _.isEmpty(this.areaModel))
    },
    updateShots() {
      this.filteredSeasons = this.playerSeasonData
        .filter(s => this.seasonDataSelectedModel.includes(s.compoundId));
      this.filteredShots = this.filterShots();

      setTimeout(() => {this.onWindowResize(null,false);},100)
    },
    toggleShotStrategies () {
      this.$nextTick(() => {
        if (this.allShotStrategies) {
          this.shotStrategyModel = []
        } else {
          this.shotStrategyModel = this.shotStrategies.filter(s => !s.isGroupHeader).map(s => s.id)
        }
        this.updateShots();
      })
    },
    onStrategyInput () {
      const hasGroupOpen = this.shotStrategyModel.includes('group_open');
      const hasGroupSet = this.shotStrategyModel.includes('group_set');
      if (hasGroupOpen || hasGroupSet) {
        let newModel = this.shotStrategyModel.filter(id => id !== 'group_open' && id !== 'group_set');
        if (hasGroupOpen) {
          const allSelected = this.openPlayIds.every(id => newModel.includes(id));
          if (allSelected) {
            newModel = newModel.filter(id => !this.openPlayIds.includes(id));
          } else {
            this.openPlayIds.forEach(id => { if (!newModel.includes(id)) newModel.push(id); });
          }
        }
        if (hasGroupSet) {
          const allSelected = this.setPieceIds.every(id => newModel.includes(id));
          if (allSelected) {
            newModel = newModel.filter(id => !this.setPieceIds.includes(id));
          } else {
            this.setPieceIds.forEach(id => { if (!newModel.includes(id)) newModel.push(id); });
          }
        }
        this.shotStrategyModel = newModel;
      }
      this.updateShots();
    },
    isStrategyGroupSelected (groupId) {
      const ids = groupId === 'group_open' ? this.openPlayIds : this.setPieceIds;
      return ids.every(id => this.shotStrategyModel.includes(id));
    },
    toggleShotTypes () {
      this.$nextTick(() => {
        if (this.allShotTypes) {
          this.shotTypeModel = []
        } else {
          this.shotTypeModel = this.shotTypes.map(function(p) { return p.id; })
        }
        this.updateShots();
      })
    },
    toggleBodyPart () {
      this.$nextTick(() => {
        if (this.allBodyParts) {
          this.bodyPartModel = []
        } else {
          this.bodyPartModel = this.bodyParts.map(function(p) { return p.id; })
        }
        this.updateShots();
      })
    },
    prepareSvgForMedia(){
      let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
      let heightAccum = 0;
      let yOffset = 120;
      parent.style.background = this.mediaModeData.bgColor;


      //COPY HEADER
      copyAndAppendElement(parent,document.querySelector(`#playerAvatarMedia${this.player.playerId}-${this.chartId}SVG`),100,0)
      heightAccum += this.avatarSize.height;
      copyAndAppendElement(parent,document.querySelector(`#pitchXA${this.player.playerId}-${this.chartId}SVG`),100,this.avatarSize.height)
      heightAccum += this.chartSize.height;
      if(this.mediaModeData.socialMedia){
        copyAndAppendElement(parent,document.querySelector(`#driblabSocialMedia${this.player.playerId}-${this.chartId}SVG`),100,this.avatarSize.height + this.chartSize.height)
        heightAccum += 50;
      }

      parent.setAttribute("width",this.chartSize.width);
      parent.setAttribute("height",heightAccum);
      return parent;
    },
    saveAsPNG() {
      if(this.mediaMode){
        downloadPng(this.prepareSvgForMedia(), "Driblab_XAMap_" + this.player.name.replace(' ','_') + ".png");
      }else{
        let svg = d3.select(`#pitchXA${this.player.playerId}-${this.chartId}`)
          .select("svg").node()
        downloadPng(svg, "Driblab_XAMap_" + this.player.name.replace(' ','_') + ".png");
      }
    },
    saveAsSVG() {
      if(this.mediaMode){
        exportSvg(this.prepareSvgForMedia(), "Driblab_XAMap_" + this.player.name.replace(' ','_'), true, this.mediaModeData.bgColor);
      }else{
        let svg = d3.select(`#pitchXA${this.player.playerId}-${this.chartId}`)
          .select("svg").node()
        exportSvg(svg, "Driblab_XAMap_" + this.player.name.replace(' ','_'));
      }
    },
    getElementToExport(){
      if(this.mediaMode){
        return this.prepareSvgForMedia();
      }else{
        let svg = d3.select(`#pitchXA${this.player.playerId}-${this.chartId}`)
          .select("svg").node()
       return svg;
      }
    },
    updateMins(){
      this.rangeMinutes = [0,_.chain(this.shots).map(s => s.min).max().value()];
      this.rangeMinutes[1] = this.rangeMinutes[1] < 90 ? 90 : this.rangeMinutes[1];
      this.minutes = this.rangeMinutes;
      this.$forceUpdate();
    },
    filterShots(includeMins = true){
      const minutesMaxFilter = this.minutes[1];
      let filtered;
      //If gameId > 0, then filter by game to show just xG of that game
      if(this.gameId > 0){
        filtered = this.shots.filter(s => s.gameId == this.gameId);
      }else{
        if(this.gameIds.length){
          filtered = this.shots.filter(s => this.gameIds.includes(s.gameId));
        }else{
          filtered = this.shots
          .filter(s =>  this.gamesModel.includes(s.gameId))
          .filter(s => this.shotTypeModel.includes(s.eventTypeId))
          .filter(s => this.shotStrategyModel.includes(s.strategyId))
          .filter(s => this.bodyPartModel.includes(s.bodyPartId));
        }
      }

      if(includeMins){
        filtered = filtered.filter(s => s.min >= this.minutes[0] && s.min <= minutesMaxFilter);
      }

      filtered = this.shotsInArea(filtered);
      //Count total minutes played of games selected
      this.minsPlayed = this.gamesFiltered.filter(g => this.gamesModel.includes(g.gameId)).reduce((acc, game) => (acc + game.minsPlayed), 0);
      return filtered;
    },
    onChartSizeChange(size){
      this.chartSize = size;
      this.avatarSize = {
        width: size.width,
        height: size.height / 4.75
      }
    },
    onLoaded(event){
      //Emit when is loaded
      this.$emit("loaded", event);
    },
    onMediaModeDataChange(event){
      this.mediaModeData = event;
      setTimeout(() => {this.onWindowResize(null,this.mediaModeData.force);},666)
    },
    async onGenerateIFrameClick(){
      this.loadingExport = true;
      let elToExport = this.getElementToExport();
      let key = v4();
      key = `${key}.json`;
      let chartObject = {
        awsKey:key,
        tool: 'key-pass-map',
        category: 'player',
        componentId: this.playerId,
        width: elToExport.getAttribute("width"),
        height: this.mediaMode ? elToExport.getAttribute("width") * 0.94 : elToExport.getAttribute("height")
      }
      let postResponse = await UserChartService.postChart(chartObject)
      let chartEntity = postResponse.data;

      this.$refs.chartExportLinksModalRef.open(chartEntity);
      this.loadingExport = false;

      let urlResponse = await UserChartService.getUploadURL(chartEntity.id,key);
      let uploadUrl = urlResponse.data;
      const gameIdsForEmbed = this.gameIds.length ? this.gameIds : (this.gamesModel || []).length ? this.gamesModel : [...new Set((this.filteredShots || []).map(s => s.gameId))];
      var jsonse = JSON.stringify({
        size: Number(chartEntity.width),
        height: Number(chartEntity.height),
        passes: this.filteredShots,
        margin: this.margin,
        circlesAndBoxes: this.checkboxCircles,
        playerPosition:this.playerPosition,
        playerSeasonData:this.filteredSeasons,
        player:this.player,
        language:this.currentUserLanguage,
        mediaModeData: this.mediaModeData,
        mediaMode: this.mediaMode,
        selectedTab: this.selectedTab,
        playerAvatarKey: 0,
        key: this.xaMap,
        socialMediaKey: 2,
        type: this.type,
        id: `${this.player.playerId}-${this.chartId}`,
        teamId: this.player && this.player.teamId,
        gameIds: gameIdsForEmbed,
        minsPlayed: this.minsPlayed,
        gameName: gameIdsForEmbed.length === 1 ? this.gameName : '',
        filterMinutesRange: this.filterMinutesText,
        filterShotTypeText: this.filterShotTypeText,
        filterShotStrategyText: this.filterShotStrategyText,
        filterBodyPartText: this.filterBodyPartText,
        chartType:"key-pass-map"
      });

      var blob = new Blob([jsonse], {type: "application/json"});
      // let blob = exportSvgToFile(elToExport);
      let uploadResponse = await DocumentService.upload(uploadUrl,blob);
      this.postSearchChart(chartEntity);
    },
    async postSearchChart(chart){
      const authorized = true;
      let metaInfo = null;
      let category = "player";
      let urlId = this.playerId;

      metaInfo = JSON.stringify({
        link: `${API_URL}${chart.id}/key/${chart.awsKey}/compId/${chart.componentId}/catId/${chart.categoryId}/tId/${chart.toolId}`
      });
      const tool = 'embed';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
      UserService.putLastSearchRendered({category,tool,id: searchResponse.data})
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
    onSelectAreaClick(){
      this.$refs.areaSelectorModalRef.open();
    },
    onAreaSelectorConfirm(event){
      if (event && event.ids && event.ids.length > 0) this.areaModel = event.ids;
      else this.areaModel = [];
      this.updateShots();
    }
  },
  destroyed() {
    d3.selectAll('.tooltip').remove();
    window.removeEventListener("resize", this.onWindowResize);
  }
};
</script>

<style>
  body > div.tooltip {
    font-family: 'NeueMontreal';
    pointer-events: none;
    position: absolute;
    background: none repeat scroll 0 0 #ffffff;
    padding: 5px 10px 5px 10px;
    border-radius: 4px;
    text-align: center;
    display: none;
    font-weight: 400;
    line-height: 1.5;
    color: #081F2C;
    box-shadow: 0px 3px 9px rgba(0, 0, 0, .15);
  }

  body > div.tooltip:after {
    box-sizing: border-box;
    display: block;
    width: 100%;
    line-height: 2.8;
    color: #ffffff;
    content: "\25BC";
    text-align: center;
  }

</style>
